<router-outlet></router-outlet>
<app-notificationtoaster></app-notificationtoaster>
